import { activityConstants } from '../constants';
import { activityService } from '../services';
import { showToast } from '../services/toast';

export const activityActions = {
    fetchActivities,
    createActivity,
    updateActivity,
    deleteActivity
};

function fetchActivities() {
    return dispatch => {
        dispatch(request());

        activityService.fetchActivitiesList()
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: activityConstants.FETCH_ACTIVITIES_REQUEST } }
    function success(activities) { return { type: activityConstants.FETCH_ACTIVITIES_SUCCESS, activities } }
    function failure(error) { return { type: activityConstants.FETCH_ACTIVITIES_FAILURE, error } }
}

function createActivity(activityDetails) {
    return dispatch => {
        dispatch(request());

        return activityService.createActivity(activityDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: activityConstants.CREATE_ACTIVITY_REQUEST } }
    function success(activities) { return { type: activityConstants.CREATE_ACTIVITY_SUCCESS, activities } }
    function failure(error) { return { type: activityConstants.CREATE_ACTIVITY_FAILURE, error } }
}

function updateActivity(activityDetails) {

    return dispatch => {
        dispatch(request());

        return activityService.updateActivity(activityDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: activityConstants.UPDATE_ACTIVITY_REQUEST } }
    function success(activities) { return { type: activityConstants.UPDATE_ACTIVITY_SUCCESS, activities } }
    function failure(error) { return { type: activityConstants.UPDATE_ACTIVITY_FAILURE, error } }

}

function deleteActivity(activityId) {

    return dispatch => {
        dispatch(request());
        
        return activityService.deleteActivity(activityId)
            .then(
                (response) => {
                    dispatch(success(activityId));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: activityConstants.DELETE_ACTIVITY_REQUEST } }
    function success(id) { return { type: activityConstants.DELETE_ACTIVITY_SUCCESS, payload: id } }
    function failure(error) { return { type: activityConstants.DELETE_ACTIVITY_FAILURE, error } }
}